import { Container, Text } from '@pixi/react'
import { t } from '@slot-nx/core'
import { TextStyle } from 'pixi.js'

const voucherContentTextStyle = new TextStyle({
  align: 'center',
  fontWeight: '500',
  fill: '#C3C3C3',
  fontFamily: 'Roboto',
  fontSize: 35,

})
export const VoucherSelectPopupContent = () => {
  return (
    <Container name="VoucherContent">
      <Text
        text={t('voucher_select_popup_content1')}
        x={0}
        y={40}
        anchor={[0.5, 0.5]}
        name="content1"
        style={voucherContentTextStyle}
      />
      <Text
        text={t('voucher_select_popup_content2')}
        x={0}
        y={90}
        anchor={[0.5, 0.5]}
        name="content2"
        style={voucherContentTextStyle}
      />
      <Text
        text={t('voucher_select_popup_content3')}
        x={0}
        y={140}
        anchor={[0.5, 0.5]}
        name="content3"
        style={voucherContentTextStyle}
      />
    </Container>
  )
}
